<template>

  <span @click="changeMe" class="_c-pointer text-nowrap" v-tippy :content="'Sort by '+coltext">
    {{coltext}}
    <Icon v-if="orderby == 'desc'" icon="ri:arrow-drop-up-line" class="text-danger"></Icon>
    <Icon v-else-if="orderby == 'asc'" icon="ri:arrow-drop-down-line" class="text-danger"></Icon>
    <Icon v-else icon="ri:arrow-drop-right-line" class="text-muted"></Icon>
  </span>

</template>
<script>

  export default{
    props: ['orderby', 'coltext'],
    methods : {
      changeMe() {
        if(this.orderby == 'desc'){
          this.$emit('update:orderby', 'asc');
        } else if(this.orderby == 'asc') {
          this.$emit('update:orderby', '');
        } else {
          this.$emit('update:orderby', 'desc');
        }
        this.$emit('do');
      }
    }
  }
</script>
